import { FormControl } from "@angular/forms";
import { messages } from "../resources/messages";

export const macAddressRegex = /^[A-F0-9]{2}(?:[:-]?[A-F0-9]{2}){5}(?:,[A-F0-9]{2}(?:[:-]?[A-F0-9]{2}){5})*$/; // NOSONAR
export const macAddressValid = (control: FormControl) =>
    macAddressRegex.test(control.value || 0) ? null : { macAddress: messages.validation.macAddress };
